import styled from "styled-components";

export const WeightStyled = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin-top: 8px;

  .weight-input {
    padding: 3px 7px;
    border-radius: 8px;
    background-color: #ffffff;
  }

  .weight-kilo {
    position: absolute;
    left: 6px;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
  }
`;
